

import React from 'react';
import {Spin } from 'antd';
import LoadingCSS from './Loading.module.scss';

const Loading  = (props) => {
    return (
       <div className={LoadingCSS.Loading}>
           <Spin spinning={props.loading}></Spin>
       </div>
    );
}

export default Loading;